import { AdminTenantDetails } from '@hakimo-ui/hakimo/types';
import { useTenantMonitoringUsers } from '@hakimo-ui/hakimo/data-access';
import { Modal, Tabs } from '@hakimo-ui/shared/ui-base';
import { useState } from 'react';
import { MonitoringTenantsTab } from './components/MonitoringTenantsTab';
import { MonitoringUsersTab } from './components/MonitoringUsersTab';
import { MONITORING_TABS, MonitoringTabId } from './util';

interface Props {
  open: boolean;
  onClose: () => void;
  tenant: AdminTenantDetails;
}

export function UpdateMonitoringModal({ open, onClose, tenant }: Props) {
  const [activeTab, setActiveTab] = useState<MonitoringTabId>('tenants');
  const [isBusy, setIsBusy] = useState(false);

  const monitoringUsersQuery = useTenantMonitoringUsers(tenant.id, open);
  const groups = monitoringUsersQuery.data?.groups;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Manage Hakimo Monitoring"
      closable={!isBusy}
      disableBackdropClose={isBusy}
    >
      <div className="flex h-[42rem] max-h-[85vh] w-[36rem] flex-col">
        <Tabs<MonitoringTabId>
          items={MONITORING_TABS}
          activeTabId={activeTab}
          onChange={setActiveTab}
        />
        <div className="min-h-0 flex-1">
          <div className={activeTab === 'tenants' ? 'h-full' : 'hidden'}>
            <MonitoringTenantsTab
              tenant={tenant}
              open={open}
              groups={groups}
              onClose={onClose}
              onBusyChange={setIsBusy}
            />
          </div>
          <div className={activeTab === 'users' ? 'h-full' : 'hidden'}>
            <MonitoringUsersTab
              tenantId={tenant.id}
              open={open}
              groups={groups}
              isLoading={monitoringUsersQuery.isFetching}
              onBusyChange={setIsBusy}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default UpdateMonitoringModal;
